<div class="tab-content-pad">
  <div *ngIf="output[0]">
    <ng-container *ngIf="output[0] as c">
      <div class="detail-card">

        <!-- ── Card Header ── -->
        <div class="detail-card-header">
          <div class="employee-identity">
            <img class="employee-avatar" [src]="imgUrl" alt="Brand image">
            <div>
              <p class="employee-name">{{ name }}</p>
              <span class="employee-role-badge">Brand</span>
            </div>
          </div>
          <a class="btn-edit" (click)="getValue(); EditBrands();">
            <i class="fas fa-pencil-alt"></i> Edit
          </a>
        </div>

        <!-- ── Fields Grid ── -->
        <div class="detail-fields-grid">

          <div class="detail-field-item">
            <span class="field-label">Brand Code</span>
            <span class="field-value" [class.empty]="!c.brand_code">
              {{ c.brand_code || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Brand Manager</span>
            <span class="field-value" [class.empty]="!c.brand_manager_name">
              {{ c.brand_manager_name || '—' }}
            </span>
          </div>

        </div>

      </div>
    </ng-container>
  </div>
</div>